import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles, Grid}from 'material-ui';
import {builderStyles} from '../style/builder';
import PageVersionsTable from './PageVersionsTable';
import PageVersionsHeaderInfo from './PageVersionsHeaderInfo';
import PageVersionDeletePopup from './PageVersionDeletePopup';
import PageVersionViewPopup from './PageVersionViewPopup';
import ScrollToTop from '../../../components/scroll-top/ScrollToTop';
import {
    getPage,
    fetchPageVersions,
    fetchPageVersion,
    deletePageVersion,
    updatePageVersion
} from '../thunks';
import {
    openViewPageVersionPopup,
    closeViewPageVersionPopup,
} from '../actions';

class PageVersionsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            versionId: null,
        };
    }

    componentWillMount() {
        this.props.getPage(this.props.pageId);
        this.props.fetchPageVersions(this.props.pageId);
    }

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    handleOpenDeletePopup = (versionId) => {
        this.setState({
            open: true,
            versionId: versionId
        });
    };

    handleCloseDeletePopup = () => {
        this.setState({
            open: false,
            versionId: null
        });
    };

    deletePageVersion = () => {
        this.props.deletePageVersion(this.state.versionId)
        this.setState({
            open: false,
            versionId: null
        });
    }

    render() {

        const {
            classes, pageId, pageMeta, fullPage, pageVersions, 
            pageSections, pageVersion, viewPageVersionPopup
        } = this.props;

        return (
            <Grid item xs={12}>
                <PageVersionsHeaderInfo 
                    page={pageMeta}
                    classes={classes}
                />
                {this.props.loading === false &&
                    <PageVersionsTable
                        pageId={pageId}
                        page={pageMeta}
                        pageVersions={pageVersions}
                        classes={classes}
                        handleOpenDelete={this.handleOpenDeletePopup}
                        openViewPageVersionPopup={this.props.openViewPageVersionPopup}
                        fetchPageVersion={this.props.fetchPageVersion}
                    />
                }
                <PageVersionDeletePopup
                    classes={classes}
                    open={this.state.open}
                    handleSubmitDelete={this.deletePageVersion}
                    handleCloseDelete={this.handleCloseDeletePopup}
                />
                <PageVersionViewPopup
                    fullPage={fullPage}
                    pageId={pageId}
                    pageMeta={pageMeta}
                    pageVersion={pageVersion}
                    pageSections={pageSections}
                    classes={classes}
                    open={viewPageVersionPopup}
                    loading={this.props.loading}
                    handleCloseView={() => {
                        this.props.closeViewPageVersionPopup();
                    }}
                    handleSubmitView={() => 
                        this.props.updatePageVersion(pageVersion, pageId)
                    }
                />

                <ScrollToTop />
                
            </Grid>
        )
    }
}

let checkStateIsDefined = (state, props) => {
    let fullPage = state.pageBuilder.pages[props.pageId] == null
        ? [] : state.pageBuilder.pages[props.pageId];

    let pageMeta = state.pageBuilder.pages[props.pageId] == null
        ? [] : state.pageBuilder.pages[props.pageId].meta;
    
    let pageSections = state.pageBuilder.pages[props.pageId] == null
        ? [] : state.pageBuilder.pages[props.pageId].sections;

        return {fullPage, pageMeta, pageSections };
};

const mapStateToProps = (state, props) => {
    let {fullPage, pageMeta, pageSections } = checkStateIsDefined(state, props);

    return {
        fullPage: fullPage,
        pageMeta: pageMeta,
        pageSections: pageSections,
        pageVersions: state.pageBuilder.pageVersions,
        viewPageVersionPopup: state.pageBuilder.viewPageVersionPopup.open,
        pageVersion: state.pageBuilder.pageVersion,
        loading: state.layout.ajaxCallsInProgress > 0,
    }
}

export default connect(mapStateToProps, {
    getPage,
    fetchPageVersions,
    fetchPageVersion,
    deletePageVersion,
    openViewPageVersionPopup,
    closeViewPageVersionPopup,
    updatePageVersion
})(withStyles(builderStyles)(PageVersionsList));


// WEBPACK FOOTER //
// ./src/containers/builder/versions/PageVersionsIndex.jsx